module.exports = __webpack_public_path__ + "img/gh.156c6b1.webp";